import styled from 'styled-components';

export const Button = styled.button`
  background: transparent;
  border: none;
  outline: none;
`;
